import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'smart-root',
  template: '<router-outlet></router-outlet>'
})

export class AppComponent {

  title = 'Back-Office';

  // styles = (sessionStorage.getItem('styles')) ? JSON.parse(sessionStorage.getItem('styles')) : {}

  // @HostBinding('style.--primary-color-bg') get primaryColor() {
  //   return `${this.styles.primary_color_bg}`;
  // }

  // @HostBinding('style.--primary-color-text') get primaryTextColor() {
  //   return `${this.styles.primary_color_text}`;
  // }

  // @HostBinding('style.--normal-color-text') get normalTextColor() {
  //   return `${this.styles.normal_color_text}`;
  // }

  // @HostBinding('style.--table-color-bg') get tableColor() {
  //   return `${this.styles.table_color_bg}`;
  // }

  // @HostBinding('style.--table-color-text') get tableTextColor() {
  //   return `${this.styles.table_color_text}`;
  // }

  // @HostBinding('style.--progress-color-bg') get progressColor() {
  //   return `${this.styles.progress_color_bg}`;
  // }

  // @HostBinding('style.--header-color-bg') get headerColor() {
  //   return `${this.styles.header_color_bg}`;
  // }

  // @HostBinding('style.--tab-color-text') get tabTextColor() {
  //   return `${this.styles.tab_color_text}`;
  // }

  // @HostBinding('style.--tab-act-color-text') get tabActTextColor() {
  //   return `${this.styles.tab_act_color_text}`;
  // }

  // @HostBinding('style.--toggle-color-bg') get toggleColor() {
  //   return `${this.styles.toggle_color_bg}`;
  // }

  // @HostBinding('style.--toggle-color-text') get toggleTextColor() {
  //   return `${this.styles.toggle_color_text}`;
  // }

  // @HostBinding('style.--menu-color-bg') get menuColor() {
  //   return `${this.styles.menu_color_bg}`;
  // }

  // @HostBinding('style.--menu-color-text') get menuTextColor() {
  //   return `${this.styles.menu_color_text}`;
  // }

  // @HostBinding('style.--menu-sub-color-bg') get menuSubColor() {
  //   return `${this.styles.menu_sub_color_bg}`;
  // }

  // @HostBinding('style.--menu-sub-color-text') get menuSubTextColor() {
  //   return `${this.styles.menu_sub_color_text}`;
  // }

  // @HostBinding('style.--menu-hover-color-bg') get menuHoverColor() {
  //   return `${this.styles.menu_hover_color_bg}`;
  // }

  // @HostBinding('style.--menu-hover-color-text') get menuHoverTextColor() {
  //   return `${this.styles.menu_hover_color_text}`;
  // }
}
